<template>
  <v-navigation-drawer width="350" v-model="drawer" color="grey lighten-4" app>
    <template v-slot:prepend>
      <v-toolbar height="130" color="light-blue darken-4" flat>
        <v-toolbar-title class="white--text mt-12 font-weight-medium"
          >Administration</v-toolbar-title
        >
        <span class="mt-12 ml-12">
          <v-btn v-if="isLoggedIn" text x-small @click="logout" color="white">
            <v-icon size="12" left>mdi-logout</v-icon>
            <span>Deconnexion</span>
          </v-btn>
        </span>
      </v-toolbar>
    </template>

    <v-list nav>
      <v-list-group prepend-icon="mdi-lightbulb" value="true">
        <template v-slot:activator>
          <v-list-item-title>Projets</v-list-item-title>
        </template>

        <v-list-item
          v-for="(projet, i) in projets"
          :key="i"
          :to="projet.to"
          link
        >
          <v-list-item-icon>
            <v-icon v-text="projet.icon"></v-icon>
          </v-list-item-icon>
          <v-list-item-title v-text="projet.text"></v-list-item-title>
        </v-list-item>
      </v-list-group>

      <v-list-group prepend-icon="mdi-camera" value="true">
        <template v-slot:activator>
          <v-list-item-title>Medias</v-list-item-title>
        </template>

        <v-list-item v-for="(med, i) in medias" :key="i" :to="med.to" link>
          <v-list-item-icon>
            <v-icon v-text="med.icon"></v-icon>
          </v-list-item-icon>
          <v-list-item-title v-text="med.text"></v-list-item-title>
        </v-list-item>
      </v-list-group>

      <v-list-group prepend-icon="mdi-badge-account" value="true">
        <template v-slot:activator>
          <v-list-item-title>Carriére</v-list-item-title>
        </template>

        <v-list-item
          v-for="(career, i) in carriere"
          :key="i"
          :to="career.to"
          link
        >
          <v-list-item-icon>
            <v-icon v-text="career.icon"></v-icon>
          </v-list-item-icon>
          <v-list-item-title v-text="career.text"></v-list-item-title>
        </v-list-item>
      </v-list-group>

      <v-list-group prepend-icon="mdi-camera" value="true">
        <template v-slot:activator>
          <v-list-item-title>Accueil</v-list-item-title>
        </template>

        <v-list-item v-for="(h, i) in home" :key="i" :to="h.to" link>
          <v-list-item-icon>
            <v-icon v-text="h.icon"></v-icon>
          </v-list-item-icon>
          <v-list-item-title v-text="h.text"></v-list-item-title>
        </v-list-item>
      </v-list-group>

      <v-list-item v-for="(appel, i) in appels" :key="i" :to="appel.to" link>
        <v-list-item-icon>
          <v-icon v-text="appel.icon"></v-icon>
        </v-list-item-icon>
        <v-list-item-title v-text="appel.text"></v-list-item-title>
      </v-list-item>

      <!-- <v-list-item v-for="(lot, i) in lots" :key="i" :to="lot.to" link>
        <v-list-item-icon>
          <v-icon v-text="lot.icon"></v-icon>
        </v-list-item-icon>
        <v-list-item-title v-text="lot.text"></v-list-item-title>
      </v-list-item> -->
    </v-list>
  </v-navigation-drawer>
</template>

<script>
export default {
  name: 'drawer',
  data() {
    return {
      user: null,
      drawer: null,
    };
  },
  methods: {
    logout: function() {
      this.$store.dispatch('loginstore/logout').then(() => {
        this.$router.push('/');
      });
    },
  },
  computed: {
    isLoggedIn: function() {
      return this.$store.getters['loginstore/isLoggedIn'];
    },
    projets() {
      return this.$store.state.sdrawer.projets;
    },
    medias() {
      return this.$store.state.sdrawer.medias;
    },
    home() {
      return this.$store.state.sdrawer.home;
    },
    lots() {
      return this.$store.state.sdrawer.lots;
    },
    appels() {
      return this.$store.state.sdrawer.appels;
    },
    carriere() {
      return this.$store.state.sdrawer.carriere;
    },
  },
};
</script>

<style scoped></style>
